import { checkoutAccommodationOfferView } from 'checkout/selectors/view/accommodation'
import { OFFER_TYPE_TOUR_V2 } from 'constants/offer'
import { createSelector } from 'reselect'

/**
 * Leaf selector used by getDepositSettings. Kept out of the deposit index barrel so
 * getDepositSettings does not re-enter the barrel while it is still initialising.
 */
export const getOfferViewWithStatusForDeposit = createSelector(
  (state: App.State) => checkoutAccommodationOfferView(state),
  (viewsWithStatus): App.WithDataStatus<App.Checkout.AccommodationOfferView> => {
    const tourV2BundleOfferView = viewsWithStatus.data.find(item => item.offerType === OFFER_TYPE_TOUR_V2 && item.isBundled)
    return {
      hasRequiredData: viewsWithStatus.hasRequiredData,
      data: tourV2BundleOfferView ?? viewsWithStatus.data[0],
    }
  },
)
